import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Business from "@/pages/business/page";
import Quant from "@/pages/quant/page";
import Cooperation from "@/pages/cooperation/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import Contact from "@/pages/contact/page";
import Downloads from "@/pages/downloads/page";
import AdminPage from "@/pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/business",
        element: <Business />,
      },
      {
        path: "/quant",
        element: <Quant />,
      },
      {
        path: "/downloads",
        element: <Downloads />,
      },
      {
        path: "/cooperation",
        element: <Cooperation />,
      },
      {
        path: "/news",
        element: <News />,
      },
      {
        path: "/news/:id",
        element: <NewsDetail />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
